import React from "react";
import { Table, Tag, Empty, Typography, theme } from "antd";
import { useTransactions } from "../../_actions/mutations/subscription";
import { getTime } from "../../_helpers/app/dt";

const { Text } = Typography;

const HISTORY_TYPE_MAPPING = {
    topup: "Token topup",
};

function TransactionHistory({ organizationId }) {
    const { isLoading, data: transactions } = useTransactions(organizationId);
    const { token } = theme.useToken();

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case "paid":
            case "completed":
                return "success";
            case "failed":
                return "error";
            case "pending":
                return "warning";
            default:
                return "default";
        }
    };

    const getStatusIcon = (status) => {
        switch (status?.toLowerCase()) {
            case "paid":
            case "completed":
                return "fa-check-circle";
            case "failed":
                return "fa-times-circle";
            case "pending":
                return "fa-clock";
            default:
                return "fa-question-circle";
        }
    };

    const columns = [
        {
            title: "Date",
            key: "date",
            render: (_, record) =>
                getTime(record.date_created || record.transaction_date, "od"),
        },
        {
            title: "Description",
            key: "description",
            render: (_, record) => (
                <div>
                    <div style={{ fontWeight: 500 }}>
                        {record.plan_name ||
                            record.description ||
                            HISTORY_TYPE_MAPPING[record?.type] ||
                            "Subscription Payment"}
                    </div>
                    <div style={{ fontSize: "12px", color: "#888" }}>
                        {record.type || "subscription"}
                    </div>
                </div>
            ),
        },
        {
            title: "Amount",
            key: "amount",
            render: (_, record) => (
                <Text strong>₹{record.paid_amount || record.amount}</Text>
            ),
        },
        {
            title: "Status",
            key: "status",
            render: (_, record) => {
                const color = getStatusColor(record.status);
                const icon = getStatusIcon(record.status);
                // First letter capitalized for display
                const displayStatus = record.status
                    ? record.status.charAt(0).toUpperCase() +
                      record.status.slice(1)
                    : "Unknown";

                return (
                    <Tag
                        color={color}
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "5px",
                        }}
                    >
                        <i className={`fas ${icon}`} />
                        <span>{displayStatus}</span>
                    </Tag>
                );
            },
        },
    ];

    return (
        <Table
            dataSource={transactions || []}
            columns={columns}
            rowKey={(record) => record.id || Math.random()}
            loading={isLoading}
            pagination={{ pageSize: 5, size: "small" }}
            scroll={{ x: "max-content" }}
            locale={{
                emptyText: (
                    <Empty
                        description="No transactions yet"
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        style={{ padding: "32px 0" }}
                    />
                ),
            }}
            style={{ padding: "0 8px" }}
        />
    );
}

export default TransactionHistory;
